import { isMeinBuero } from '@/utils/build-env'
import Decimal from 'decimal.js'
import { dateConstants } from '../../util/constants'
import GtmService, { GtmEventTypes } from '@/modules/_services/gtm.service'
import { v4 as uuidv4 } from 'uuid'

const TAX_MULTIPLIER = 0.19
const isMeinbuero = isMeinBuero()

const createProductData = () => {
  if (isMeinbuero) {
    return {
      affiliation: 'meinbuero.de',
      product: {
        name: 'WISO MeinBüro Online',
        brand: 'WISO',
        category: 'Büro',
      },
    }
  }
  return {
    affiliation: 'orgamax.de',
    product: {
      name: 'orgaMAX Online',
      brand: 'orgaMAX',
      category: 'Büro',
    },
  }
}

export const trackPurchase = (trackingData) => {
  const {
    price,
    type,
    period,
  } = trackingData
  const tax = new Decimal(price).times(TAX_MULTIPLIER).toDP(2).toNumber()

  const transactionId = uuidv4()

  const {
    affiliation,
    product: {
      name,
      brand,
      category,
    },
  } = createProductData()

  let gtmEvent
  if (isMeinbuero) {
    gtmEvent = {
      event: GtmEventTypes.PackagePurchase,
      Zahlungsart: 'Lastschrift',
      ecommerce: {
        purchase: {
          actionField: {
            id: transactionId,
            affiliation,
            revenue: price,
            tax,
            shipping: '0',
          },
          products: [
            {
              name,
              id: type,
              price,
              brand,
              category,
              variant: 'monthly',
              quantity: '1',
            },
          ],
        },
      },
    }
  } else {
    gtmEvent = {
      event: GtmEventTypes.Purchase,
      Zahlungsart: 'Lastschrift',
      ecommerce: {
        transaction_id: transactionId,
        value: price,
        tax,
        shipping: '0',
        items: [
          {
            item_id: type,
            item_name: name,
            affiliation,
            price,
            item_brand: brand,
            item_category: category,
            item_variant: period === dateConstants.MONTH ? 'monthly' : 'yearly',
            quantity: '1',
          },
        ],
      },
    }
  }

  GtmService.pushEvent(gtmEvent)
}

export default trackPurchase
